exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-3b256226]{margin:0!important}.txt-primary[data-v-3b256226]{color:#ff5722}.txt-sub3[data-v-3b256226]{color:#828282}.txt-body2[data-v-3b256226]{color:$body2}.lp-input-text-container[data-v-3b256226]{position:relative}.lp-input-text-label[data-v-3b256226]{margin-bottom:8px;margin-right:8px;display:block;color:#363636;font-weight:700;font-size:.83rem}.lp-input-text-input[data-v-3b256226]{padding:8px 12px;font-size:.85rem;color:#363636;border-radius:3px;background-color:#fff;border:1px solid #dbdbdb;display:block}.lp-input-fixed-text[data-v-3b256226]{position:absolute;top:4px;right:-20px;font-size:.9rem;color:#666}", ""]);

// exports
